// extracted by mini-css-extract-plugin
module.exports = {"userScaleChart":"consumerComplaints_userScaleChart__1IeCI","title":"consumerComplaints_title__3Hu7U"};